import { Mesh, Vector3, Object3D } from "three";
import { DEG2RAD } from "three/src/math/MathUtils";
import { VertexNormalsHelper } from "three/examples/jsm/helpers/VertexNormalsHelper";
// const MATERIALS = [
//   'Orange',
//   'Pink',
//   'Magenta',
//   'Red',
//   'Purple',
//   'Blue',
// ]
var Meshes = /** @class */ (function () {
    function Meshes(params) {
        var _this = this;
        this._onPreRender = function () {
            var len = _this.meshes.length;
            for (var i = 0; i < len; i++) {
                var rotation = _this.meshes[i].rotation;
                rotation.y += DEG2RAD * -0.5;
                // rotation.z += DEG2RAD * 0.3;
                rotation.x += DEG2RAD * 0.3;
            }
        };
        /**
         * 指定色とマッチしたMeshのハイライト有無を変更します
         */
        this._onChangeUseSpecular = function ($colorNum) {
            for (var i = 0; i < _this.paramArray.length; i++) {
                var colorN = _this.paramArray[i].colorNum;
                if ($colorNum === colorN) {
                    _this.meshes[i].material = _this._getMaterial($colorNum);
                }
            }
        };
        this._onChangeScale = function () {
            var len = _this.meshes.length;
            for (var i = 0; i < len; i++) {
                var mesh = _this.meshes[i];
                mesh.scale.copy(_this.scale);
            }
        };
        this._onChangeGeometry = function () {
            _this.atChangeGeometry();
            var len = _this.meshes.length;
            for (var i = 0; i < len; i++) {
                var mesh = _this.meshes[i];
                mesh.geometry = _this.geometry;
                mesh.geometry.needsUpdate = true;
            }
        };
        this.manager = params.manager;
        this.materials = params.materials;
        this.materialsNum = this.materials.configs.length;
        this.meshes = [];
        this.manager.on('preRender', this._onPreRender);
        params.manager.on('preRender', this._onPreRender);
        params.manager.on('change:useSpecular', this._onChangeUseSpecular);
        this.scale = new Vector3(1, 1, 1);
    }
    Meshes.prototype.destroy = function () {
        this.manager.off('preRender', this._onPreRender);
    };
    Meshes.prototype._getMaterial = function ($colorNum) {
        return this.materials.materials[$colorNum];
    };
    /**
     * Meshを生成します
     * @param {Array<any>} $paramArray Meshのプロパティを指定します
     */
    Meshes.prototype._createMeshes = function ($paramArray) {
        this.paramArray = $paramArray;
        var len = $paramArray.length;
        for (var i = 0; i < len; i++) {
            var paramObj = $paramArray[i];
            var material = this._getMaterial(paramObj.colorNum);
            // ------------------------------ Mesh
            var mesh = new Mesh(this.geometry, material);
            mesh.name = paramObj.name ? paramObj.name + "_child" : "tgt_default_child";
            mesh.material.transparent = true;
            mesh.material.opacity = 1;
            mesh.position.set(0, 0, 0);
            var holder = new Object3D();
            holder.name = paramObj.name ? paramObj.name : "tgt_default";
            holder.add(mesh);
            this.meshes[i] = holder;
        }
    };
    Meshes.prototype._addVertexNormalsHelper = function () {
        var len = this.materialsNum;
        for (var i = 0; i < len; i++) {
            var helper = new VertexNormalsHelper(this.meshes[i], 2, 0x00ff00);
            this.meshes.push(helper);
        }
    };
    Meshes.prototype.atChangeGeometry = function () { };
    return Meshes;
}());
export { Meshes };
